import instance from "@/services/api";

export const tierPlanAPI = {
  async getResidents() {
    return await instance()
      .get("/tier/resident/read/")
      .then((res) => res?.data);
  },
  async getBlocks(resident_id) {
    return await instance()
      .get("/tier/block/read/", { params: { resident_id } })
      .then((res) => res?.data);
  },
  async getWorkGroups(block_id) {
    return await instance()
      .get("/tier/work_group/read/", { params: { block_id } })
      .then((res) => res?.data);
  },
  async getWorkTaskPlan(work_group_id, work_group_level_id = null) {
    const params = { work_group_id };
    if (work_group_level_id) {
      params.work_group_level_id = work_group_level_id;
    }
    return await instance()
      .get("/tier/work_task_plan/read/", { params })
      .then((res) => res?.data);
  },
  async updateWorkTaskPlan(body) {
    return await instance()
      .post("/tier/work_task_plan/upd/", body)
      .then((res) => res?.data);
  },
  async deleteWorkTaskPlan(body) {
    return await instance()
      .post("/tier/work_task_plan/delete/", body)
      .then((res) => res?.data);
  },
  async getWorkGroupLevelNum(work_group_id) {
    return await instance()
      .get("/tier/work_group_level_num/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async getWorkGroupLevels(work_group_id) {
    return await instance()
      .get("/tier/work_group_level_num/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async getLaborPlan(work_group_id) {
    return await instance()
      .get("/tier/labor_plan/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async updateLaborPlan(body) {
    return await instance()
      .post("/tier/labor_plan/upd/", body)
      .then((res) => res?.data);
  },
  async deleteLaborPlan(body) {
    return await instance()
      .post("/tier/labor_plan/delete/", body)
      .then((res) => res?.data);
  },
  async copyWorkTaskPlanRange(body) {
    return await instance()
      .post("/tier/work_task_plan/copy_range/", body)
      .then((res) => res?.data);
  },
  async undoWorkTaskPlan(body) {
    return await instance()
      .post("/tier/work_task_plan/undo/", body)
      .then((res) => res?.data);
  },
};

